<template>
  <div class="modal-need-stores" v-if="!hasStores">
    <div class="modal-dialog modal-dialog-centered">
      <b-container fluid class="modal-content p-4">
        <b-row class="justify-content-md-center">
          <b-col cols="12">
            <div>
              <h5 v-translate>Hi!</h5>
              <p v-translate="{siteName: this.siteName}">Here at %{siteName} we work hard and all the time to bring you the best service.</p>
              <p v-translate>Now we need you to help us filling in the infomation of all your stores, branches and warehouses (or at least one 😊 ). This will give us your working hours and exact locations you normally use, which will back to you in the form of much better and optimized service.</p>
              <div v-if="isCompanyAdmin">
                <p v-translate>Fill in the infomation of all your stores, branches and warehouses</p>
                <b-btn :to="{name: 'stores'}" variant="warning" v-translate="{storeIcon: storeIcon}" render-html="true">%{storeIcon} HERE!</b-btn>
              </div>
              <div v-else>
                <p v-translate>You don't have permissions to fill the Stores' info. Please ask your Company Administrator to do it.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { icon } from '@fortawesome/fontawesome-svg-core'
import { faStore } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'ModalNeedStores',
  data() {
    return {
      storeIcon: icon(faStore).html
    }
  },
  computed: {
    hasCompany() {
      return this.$store.getters.profile.company_id !== null
    },
    hasStores() {
      return this.$store.getters.profile && this.$store.getters.profile.company && this.$store.getters.profile.company.stores.length > 0
    },
    isCompanyAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.findIndex(x => x.name === 'company-admin') !== -1
    }
  }
}
</script>

<style lang="scss">
.modal-need-stores {
  position: fixed;
  z-index: 1002;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: rgba(255, 255, 255, .8);
  .modal-content {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
    display: flex;
  }
}
</style>
